import BannerDashboard from './banner-dashboard';

export const BannerRouter = {
  path: 'banners',
  children: [
    {
      path: '',
      element: <BannerDashboard />,
    },
  ],
};
